import { render } from "./PlatUser.vue?vue&type=template&id=ab01efa6&scoped=true"
import script from "./PlatUser.vue?vue&type=script&lang=js"
export * from "./PlatUser.vue?vue&type=script&lang=js"

import "./PlatUser.vue?vue&type=style&index=0&id=ab01efa6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab01efa6"]])

export default __exports__